// extracted by mini-css-extract-plugin
module.exports = {"banner__container":"PlayerBanner_banner__container__3U6jM","avatar__parent":"PlayerBanner_avatar__parent__2c0ls","avatar__child":"PlayerBanner_avatar__child__3vDtJ"};